/**
 * 에디터 옵션 설정
 */

/**
 * 1단계 에디터 옵션
 */
export const step1EditorOptions = {
    fontSize: 14,
    minimap: { enabled: true },
    scrollBeyondLastLine: false,
    automaticLayout: true,
    wordWrap: 'on',
    lineNumbers: 'on',
    roundedSelection: false,
    readOnly: true, // 읽기 전용으로 변경
    cursorStyle: 'line',
    fontFamily: 'Consolas, "Courier New", monospace',
    tabSize: 4,
    glyphMargin: true, // 라인 번호 옆 여백 활성화 (클릭 영역 확보)
    selectOnLineNumbers: false, // 라인 번호 선택 방지
    disableLayerHinting: true,
    suggest: {
        showKeywords: true,
        showSnippets: true,
    },
};

/**
 * 2단계 편집 모드 에디터 옵션 (상세보기에서 사용)
 */
export const step2EditableEditorOptions = {
    fontSize: 14,
    minimap: { enabled: true },
    scrollBeyondLastLine: false,
    automaticLayout: true,
    wordWrap: 'on',
    lineNumbers: 'on',
    roundedSelection: false,
    readOnly: false,
    cursorStyle: 'line',
    fontFamily: 'Consolas, "Courier New", monospace',
    tabSize: 4,
    glyphMargin: false,
    disableLayerHinting: true,
    suggest: {
        showKeywords: true,
        showSnippets: true,
    },
};

/**
 * 2단계 에디터 옵션 (동적으로 readOnly 설정)
 * @param {boolean} isVulFile - 1단계 파일인지 여부
 * @returns {object} 에디터 옵션 객체
 */
export const getStep2EditorOptions = (isVulFile) => ({
    fontSize: 14,
    minimap: { enabled: true },
    scrollBeyondLastLine: false,
    automaticLayout: true,
    wordWrap: 'on',
    lineNumbers: 'on',
    roundedSelection: false,
    readOnly: isVulFile, // 1단계 파일은 읽기 전용
    cursorStyle: 'line',
    fontFamily: 'Consolas, "Courier New", monospace',
    tabSize: 4,
    glyphMargin: isVulFile, // 라인 선택 체크 표시 제거
    disableLayerHinting: true,
    suggest: {
        showKeywords: true,
        showSnippets: true,
    },
});
